import { css, jsx } from '@emotion/react';
import { ZapierLogo } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../../universal-nav/utils/avroEvents';
import { baseReset, boxSizing } from '../../../utils/style-mixins/reset';
const Styles = {
    root: css `
    ${baseReset};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 5px;
    cursor: default;
    user-select: none;
  `,
    cell: css `
    ${boxSizing};
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
};
export const Branding = () => {
    return (jsx("div", { css: Styles.root, "data-testid": "branding", "data-zds": true },
        jsx("a", { "aria-label": "Zapier", href: "https://zapier.com", onClick: () => {
                emitUserInteractionEvent({
                    interaction_name: 'universal_footer_click',
                    destination_href: 'https://zapier.com',
                    event_action: 'click',
                    option_selected: 'logo',
                });
            } },
            jsx("div", { "aria-hidden": true, css: Styles.cell, "data-zds": true },
                jsx(ZapierLogo, { width: 81, height: 22 })))));
};
//# sourceMappingURL=Branding.js.map
// @zapier/universal-layout@11.0.68 (90b2cf70c)
